<template>
  <div>

    <v-app v-scroll="onScroll">

      <z-cadastro-drawer></z-cadastro-drawer>

      
      <v-app-bar color="primary" dark app fixed clipped-right>
        <v-app-bar-nav-icon v-show="!drawer_clientes" @click.stop="$store.state.drawer = !$store.state.drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>{{ tituloTela }}</v-toolbar-title>
        <z-dev>
          <v-toolbar-title>
            <z-count-down ref="counter"></z-count-down>
          </v-toolbar-title>
        </z-dev>

        <window-menu v-if="!IS_PRODUCTION"></window-menu>

        <v-progress-circular
          v-show="loading"
          indeterminate
          :size="25"
          :width="3"
          color="white"
          class="ml-4"
        ></v-progress-circular>

        <v-spacer></v-spacer>        

        <v-btn small v-ripple="false" id="qa-compartilhar-top" icon text v-show="$auth.can('compartilharcontas:acessar')">
          <v-icon @click="compartilharContas().abrir()">{{$icon.WHATSAPP}}</v-icon>
          <v-tooltip bottom activator="#qa-compartilhar-top">Compartilhar Contas</v-tooltip>
        </v-btn>

        <v-toolbar-items v-if="isLojaSet && configuracoes.USAR_SISTEMA_MULTI_LOJAS == true">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" @click="escolherLoja">
                <v-icon icon class="mr-3">mdi-swap-horizontal-bold</v-icon>
                Loja: {{ loja_atual.abreviacao }}
              </v-btn>
            </template>
            Trocar de Loja
          </v-tooltip>
        </v-toolbar-items>

        <!-- <quick-navigation></quick-navigation> -->

        <v-menu
          offset-y
          transition="slide-y-transition"
          origin="center center"
          :nudge-bottom="15"
          v-dev
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon text v-on="on" v-bind="attrs" id="btn-perfil">
              <v-avatar size="36px">
                <img src="https://pt.gravatar.com/userimage/137219454/70437e2a847a7a971a437def22577a44.jpg" alt="Michael Wang"/>
                <!-- <v-icon>mdi-account</v-icon> -->
              </v-avatar>
            </v-btn>
            <v-tooltip bottom activator="#btn-perfil">
              Meu Perfil
            </v-tooltip>
          </template>

          <v-card>
            <v-list dense>
              <v-list-item>
                <v-list-item-avatar>
                  <img src="https://pt.gravatar.com/userimage/137219454/70437e2a847a7a971a437def22577a44.jpg" alt="John">
                  <!-- <v-icon>mdi-account</v-icon> -->
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{$auth.getUser().name}}</v-list-item-title>
                  <v-list-item-subtitle>{{$auth.getUser().perfil.descricao}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list class="pa-0">
              <v-list-item
                v-for="(item, index) in items2"
                rel="noopener"
                ripple="ripple"
                :disabled="item.disabled"
                :key="index"
                @click="item.click"
              >
                <v-list-item-action v-if="item.icon">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <!-- <v-list-item>
          <v-list-item-avatar>
            <v-icon>mdi-account</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{$auth.getUser().name}}</v-list-item-title>
            <v-list-item-subtitle>{{$auth.getUser().perfil.descricao}}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="sair">
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item> -->

      </v-app-bar>

      <app-drawer width="250"></app-drawer>
      <app-drawer-clientes width="250" :drawer.sync="drawer_clientes"></app-drawer-clientes>

      <v-main class="grey lighten-4" style="padding-bottom: 200px">
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </v-main>

      <v-snackbar
        bottom
        v-model="snackbar.exibir"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        {{ snackbar.mensagem }}
        <v-btn dark text color="primary" @click.native="snackbar.exibir = false">Fechar</v-btn>
        <v-btn dark text color="primary" @click.native="snackbar.exibir = false">Detalhes</v-btn>
      </v-snackbar>

      <z-notificacao ref="notificacao"></z-notificacao>

      <!-- <pedido ref="pedido"></pedido> -->
      <escolher-loja ref="dialogoEscolherLoja"></escolher-loja>

      <z-debug-info v-if="!IS_PRODUCTION"></z-debug-info>

      <v-slide-y-transition>
        <quick-access v-show="showButton"></quick-access>
      </v-slide-y-transition>

      <!-- <zCompartilharContas ref="compartilhar"></zCompartilharContas> -->


      <CompartilharConta ref="dialogoCompartilharConta"></CompartilharConta>
      
    </v-app>
  </div>
</template>


<script setup>
import { useConfigStore } from '@/app/store/pinia/configuracoes';
import { useUserActivity } from '@/app/composables/useUserActivity';

const configStore = useConfigStore();
const { timer, showSnackbar, isLocked, resetTimer } = useUserActivity(15, configStore.configuracoes.BLOQUEAR_TELA * 60); // 15 minutos de inatividade, aviso aos 20 segundos
</script>


<script>
// import MenuPrincipal from "@/pages/layout/MenuPrincipal";
import AppDrawer from "./AppDrawer";
import WindowMenu from "./WindowMenu";
import AppDrawerClientes from "./AppDrawerClientes";
// import Pedido from "@/pages/pedidos/dialogo/Pedido";
import events from "@/app/mixins/events";
import config from "@/app/config";
import { mapState } from "vuex";
import EscolherLoja from "@/pages/EscolherLoja";
import zDebugInfo from "@/components/zDebugInfo";
import CompartilharConta from "@/pages/contaspagar/CompartilharConta.vue";

import QuickNavigation from "./QuickNavigation.vue";
import QuickAccess from "./QuickAccess.vue";

import createEcho from "@/app/echo.js";

// Opção 1: Import direto (recomendado para Webpack/Vite)
import audioFile from "@/assets/2.mp3";

// Opção 2: Usando require (para Webpack)
// const audioFile = require("@/assets/2.mp3");

// Opção 3: Import dinâmico
// const audioFile = await import("@/assets/2.mp3");

export default {
  name: "AppLayout",
  mixins: [events],
  components: {
    // MenuPrincipal,
    AppDrawer,
    AppDrawerClientes,
    // Pedido,
    EscolherLoja,
    WindowMenu,
    zDebugInfo,
    QuickNavigation,
    QuickAccess,
    CompartilharConta,
  },

  provide() {
    return {
      notificacao: this.notificacao(),
      compartilharconta: this.compartilharContas(),
    };
  },

  inject: {
    toast: "toast",
  },

  data() {
    return {
      IS_PRODUCTION: config.IS_PRODUCTION,
      // drawer_clientes: false,
      clipped: false,
      drawer: true,
      fixed: false,
      items: [
        { icon: "home", title: "Tela Inicial", to: "/" },
        { icon: "card_travel", title: "Catálogo", to: "/catalogo" },
        { icon: "shopping_cart", title: "Vendas", to: "/vendas" },
        { icon: "check_circle", title: "Compras", to: "/compras" },
        { icon: "monetization_on", title: "Financeiro", to: "/financeiro" },
        { icon: "assignment", title: "Relatórios", to: "/relatorios" },
      ],

      items2: [
        {
          icon: "mdi-account-circle",
          href: "#",
          title: "Meu Perfil",
          click: (e) => {
            this.$router.push({name: 'UsuariosProfile'});
          },
        },
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Tela Inicial",
      snackbar: {
        exibir: false,
        mensagem: "",
        timeout: 3000,
        color: "",
      },
      lastScroll: 0,
      showButton: true,
      timerText: '00:02:00',
    };
  },

  computed: {
    // ...mapStores(useConfigStore),
    ...mapState({
      tituloTela: (state) => state.titulo_tela,
      loading: (state) => state.loading,
      loja_atual: (state) => state.lojas.loja_atual,
    }),

    styleContent() {
      return {
        paddingLeft: !this.drawer ? "" : "250px !important",
      };
    },

    drawer_clientes: {
      get() {
        return this.$store.state.financeiro.drawer_clientes;
      },

      set(value) {
        this.$store.commit("financeiro/SET_DRAWER_CLIENTES", value);
      },
    },

    isLojaSet() {
      // return Object.keys(this.loja_atual).length === 0;
      return this.loja_atual != null;
    },

    configuracoes() {
      return this.$store.state.configuracoes;
    },
  },

  mounted() {
    // this.startEchoChannels();
    // this.$refs.counter.startTimer(0, 1, 0); // Inicia o contador com 2 minutos
  },

  methods: {
    notificacao() {
      const vm = this;
      return {
        notificar(mensagem, timeout = 3) {
          vm.$refs.notificacao.exibir({
            mensagem: mensagem,
            timeout: timeout * 1000,
          });
        },
        error(mensagem, erro=null, timeout = 3) {
          const mensagemErro = erro ? '<br> Erro: ' + erro : "";
          vm.$refs.notificacao.exibir({
            mensagem: mensagem + mensagemErro,
            cor: "error",
            timeout: timeout * 1000,
          });
        },
      }
    },

    compartilharContas() {
      const vm = this;
      return {
        abrir(conta) {
          vm.$refs.dialogoCompartilharConta.abrir(conta);
        },
      }
    },

    irParaInicio() {
      this.$router.push({ name: "Home" }).catch(() => {});
    },

    navegar(rota) {
      this.$router.push({ name: rota }).catch(() => {});
    },

    escolherLoja() {
      const podeEscolher = this.$auth.isAdmin() || this.$auth.temPermissao("lojas:trocar");
      if (podeEscolher) {
        this.$refs.dialogoEscolherLoja.abrir();
      }
    },

    sair() {
      setTimeout(() => {
        this.$auth.logout();
        this.$router.push("/login");
      }, 1000);
    },

    onScroll(e) {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      this.showButton = currentScroll < this.lastScroll || currentScroll < 100;
      this.lastScroll = currentScroll;
    },

    startEchoChannels() {
      window.Echo = createEcho(this.$auth.user.token);

      const user = this.$auth.user;
      console.log(user);

      console.log('Whatsapp component mounted');

      Echo.private(`whatsapp.connected.${user.id}`)
      .listen('WhatsappConnectedEvent', (e) => {
          console.log(e);
          console.log('Whatsapp conectado');
          // conectado.value = true;
          // keepverifing.value = false;
          // dialogQRCode.value.fechar();
          this.notificacao().notificar(`Whatsapp conectado! ${user.name}`);
      });

      Echo.channel(`whatsapp.connected`)
      .listen('WhatsappConnectedEventAll', (e) => {
          // eventbus.notificar('Whatsapp conectado!');
          this.toast.notificar(`Whatsapp conectado All! ${user.name}`);

          // Tocar som de notificação
          const audio = new Audio(audioFile);
          audio.play().catch(error => {
            console.log('Erro ao tocar som de notificação:', error);
          });
      });
    }
  },
};
</script>